import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Horse Riding Instructor | New York, USA',
  text: "The trot progression lessons completely transformed how my students develop. Each week feels like a real step forward — and I'm not the one scrambling to figure out what that step should be."
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Riding Instructor | Melbourne, Australia',
  text: 'I used to get anxious every time a student at a different level joined the group. Now I open the Adaptation System and I have three versions of every exercise ready before anyone walks in. That bonus alone changed everything.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Horse Riding Instructor | Toronto, Canada',
  text: "I review the key cues before every session and walk in knowing exactly what I'm going to say. The Corrections Manual is something I use every single week without exception."
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Riding Instructor | London, UK',
  text: "The Emergency Lesson Vault saved my entire week when we had two days of bad weather. I had 50 alternatives ready — my students didn't miss a beat."
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'Horse Riding Instructor | Dublin, Ireland',
  text: 'What I love most is that the six volumes connect. When my student finishes Volume 3, I already know exactly what comes next. There is no gap, no searching, no guessing.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-78" data-mp="3mo0y8ijh6ggq">
      <div className="max-w-6xl mx-auto" data-id="element-79" data-mp="3hq7ppiup9ada">
        <div className="text-center mb-16" data-id="element-80" data-mp="3hpftq6x6xamh">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest" data-id="element-81" data-mp="3hslh9hq684g3">
            What riding instructors who already have the system are saying:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-82" data-mp="26d59iowiimtn">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white border border-gold-aged/40 p-8 rounded-2xl relative shadow-[0_4px_20px_rgba(18,53,36,0.06)] ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-83" data-mp="27qeso6sbsa0n" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-leather" size={48} aria-hidden="true" data-id="element-84" data-mp="1ts6q9jcisgi3" />

              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-85" data-mp="1fyyvxjx216wp">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-86" data-mp="163dwntjdekqn" data-mpi={j} />)}
              </div>

              <p className="text-ink italic mb-8 relative z-10 leading-relaxed" data-id="element-87" data-mp="1b1738nol5grg">
                “{t.text}”
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-88" data-mp="mh3q0tzsoswg">
                <div className="w-12 h-12 rounded-full bg-forest border border-gold flex items-center justify-center text-ivory font-bold text-lg" data-id="element-89" data-mp="min7up13nc0c">
                  {t.initials}
                </div>
                <div data-id="element-90" data-mp="wdoyxqexqo5k">
                  <div className="font-bold text-forest" data-id="element-91" data-mp="whmj8fd91lr1">{t.name}</div>
                  <div className="text-xs text-warmgray" data-id="element-92" data-mp="1adgis7s4uyrh">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}